import {
  Accordion,
  Box,
  Flex,
  Link,
  StarCircledIcon,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import { pluralize } from '@iheartjane/utils';
import type { PropsWithChildren } from 'react';

/* eslint-disable-next-line no-restricted-imports */
import type { CrmIntegration, CrmRedemption } from '@jane/shared/models';

import { ApplyableDiscount } from './applyableDiscount';

export const CustomerLoyaltyPointsAccordionHeader = ({
  appliedRedemptions,
  availablePoints,
  crmIntegration: { wallet_state, jane_redeemable_rewards },
  handleRemoveCrmRedemption,
  loading,
  storeRewardLabel,
}: {
  appliedRedemptions: readonly CrmRedemption[];
  availablePoints: number;
  crmIntegration: CrmIntegration;
  handleRemoveCrmRedemption: (id: string) => void;
  loading: boolean;
  storeRewardLabel?: string | null;
}) => {
  const headingTitle = `Use store ${
    storeRewardLabel ? storeRewardLabel : 'rewards'
  }`;
  const isMobile = useMobileMediaQuery({});

  if (loading) {
    return <Header>{headingTitle}</Header>;
  }

  return (
    <Accordion.Heading px={isMobile ? 24 : 40} py={20}>
      <Header>{headingTitle}</Header>
      <Box pl={40}>
        {wallet_state === 'unlocked' && (
          <Typography>
            {pluralize({ noun: 'pt', number: availablePoints })}
          </Typography>
        )}
        {wallet_state === 'locked' && (
          <Typography>Authenticate your account to unlock rewards</Typography>
        )}
        {appliedRedemptions.length > 0 &&
          jane_redeemable_rewards.length > 0 && (
            <Box pt={16}>
              <Typography variant="body-bold">Applied rewards</Typography>
              <ul>
                {appliedRedemptions.map((redemption) => (
                  <ApplyableDiscount
                    key={redemption.id}
                    applied
                    dataTestId="applied-redemption"
                    enabled
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveCrmRedemption(
                        redemption.id?.toString() || ''
                      );
                    }}
                    text={`${redemption.reward_name} (${pluralize({ noun: 'pt', number: redemption.point_value })}) `}
                  >
                    <Link>Remove</Link>
                  </ApplyableDiscount>
                ))}
              </ul>
            </Box>
          )}
      </Box>
    </Accordion.Heading>
  );
};

const Header = ({ children }: PropsWithChildren) => (
  <Flex alignItems="center" justifyContent="space-between">
    <Flex alignItems="center">
      <StarCircledIcon />
      <Typography color="grays-black" ml={16} variant="body-bold">
        {children}
      </Typography>
    </Flex>
    <Accordion.Indicator iconSize="md" />
  </Flex>
);
